import { useEffect, useState } from 'react';

import logo from '../../assets/assessoria/logoSulamericaWhite.svg';
import chevronDown from '../../assets/svgs/chevron_down-icon.svg';
import chevronUp from '../../assets/svgs/chevron_up-icon.svg';
import closeIcon from '../../assets/svgs/close-icon.svg';
import hamburgerIcon from '../../assets/svgs/hamburgerIcon.svg';
import logoutIcon from '../../assets/svgs/logout-icon.svg';
import { useAuthContext } from '../../contexts/AuthContext';
import { CustomIcon } from '../widgets/CustomIcon';

type itemsType = {
  title: string;
  icon: JSX.Element;
  action: () => void;
  options: {
    name: string;
    link: string;
  }[];
};

type HeaderGlobalMobileProps = {
  items?: itemsType[];
};

export const HeaderGlobalMobile = ({ items }: HeaderGlobalMobileProps) => {
  const { logout } = useAuthContext();

  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const { user } = JSON.parse(localStorage.getItem('pdn:user') as string) || {
    user: { name: 'Joaquim Bira' }
  };

  const userName = user.name.split(' ');

  const userAvatar =
    user.name.split(' ').length > 1
      ? user.name.split(' ')[0].charAt(0).toUpperCase() +
        user?.name.split(' ')[1].charAt(0).toUpperCase()
      : user.name.split(' ')[0].charAt(0).toUpperCase() +
          user?.name.split(' ')[0].charAt(0).toUpperCase() || '';

  // const hanleDropdown = () => {
  //   setDropdownIsOpen(!dropdownIsOpen);
  // };

  const itemsDefault = items
    ? items
    : [
        {
          title: 'Sair',
          icon: <CustomIcon src={logoutIcon} />,
          action: () => logout(),
          options: []
        }
      ];

  const disableScroll = () => {
    if (menuIsOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  useEffect(() => {
    disableScroll();
  }, [menuIsOpen]);

  return (
    <>
      <div className="tw-h-[64px] tw-bg-[#001E64] tw-flex tw-justify-between tw-px-[16px] tw-py-[20px] md:tw-hidden">
        <img src={logo} className="tw-w-[123px] tw-h-[32px]" alt="Logo" />
        <button onClick={() => setMenuIsOpen(!menuIsOpen)}>
          <CustomIcon src={hamburgerIcon} />
        </button>
      </div>
      {menuIsOpen && (
        <div className="tw-absolute tw-bg-[#FFFFFF]  tw-max-w-full tw-h-full tw-z-50 tw-w-full">
          <div className="tw-p-5 tw-flex tw-justify-between tw-gap-[5px]">
            <div className="tw-flex tw-gap-[10px]">
              <div className="tw-rounded-full tw-w-9 tw-p-2 tw-h-9 tw-bg-[#FF8C00] tw-flex tw-items-center tw-justify-center tw-text-[#FFFFFF] tw-text-[0.75rem] tw-font-semibold">
                {userAvatar}
              </div>
              <div className="tw-flex tw-flex-col">
                {userName.map((name, index) => (
                  <div key={index} className="">
                    {index === 0 ? (
                      <p className="tw-text-[1.25rem] tw-text-[#011c65] tw-flex">
                        Olรก, &nbsp; <strong>{name}</strong>
                      </p>
                    ) : index <= 2 ? (
                      <p className="tw-text-[1.25rem] tw-text-[#011c65] tw-font-bold tw-flex">
                        {name}
                      </p>
                    ) : null}
                  </div>
                ))}
              </div>
            </div>
            <button
              className="tw-font-bold tw-text-[18px] tw-h-[18px] tw-w-[18px] tw-text-center"
              onClick={() => setMenuIsOpen(false)}
            >
              <CustomIcon src={closeIcon} width={15} height={15} />
            </button>
          </div>
          <hr />
          <div className="">
            <p className="tw-text-[1rem] tw-text-[#828282] tw-py-3 tw-px-4">
              Minha conta
            </p>
            {itemsDefault?.map((item, index) => {
              return (
                <div key={index} className="tw-flex tw-flex-col">
                  <a href={process.env.REACT_APP_PORTAL_URL}>
                    <button
                      className="tw-w-full tw-flex tw-gap-4 tw-py-3 tw-px-4 tw-text-[#001E64] hover:tw-text-[#146CFA] hover:tw-bg-[#E6F7FF] hover:tw-font-bold tw-cursor-pointer tw-full tw-justify-between"
                      onClick={() => {
                        item.action();
                      }}
                    >
                      <div className="tw-flex tw-gap-2">
                        <span>{item.icon}</span>
                        <p>{item.title}</p>
                      </div>
                      {item.options.length >= 1 && (
                        <CustomIcon
                          src={!dropdownIsOpen ? chevronUp : chevronDown}
                        />
                      )}
                    </button>
                  </a>
                  {/* {dropdownIsOpen &&
                    item.options.map((option, cont) => {
                      return (
                        <button
                          key={cont}
                          className="tw-w-full tw-flex tw-justify-start tw-gap-4 tw-py-2 tw-px-4 tw-text-[#001E64] hover:tw-text-[#146CFA] hover:tw-bg-[#E6F7FF] hover:tw-font-bold tw-cursor-pointer"
                          onClick={() =>
                            (window.location.pathname = option.link)
                          }
                        >
                          <span>{option.name}</span>
                        </button>
                      );
                    })} */}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
